var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"page",attrs:{"fluid":""}},[_c('b-row',{staticClass:"firstRow"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"policy",domProps:{"innerHTML":_vm._s(_vm.policy)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }